import React from "react";
import classes from "./shippingPolicy.module.css";
import Footer from "../../components/footer";

const ShippingPolicy = () => {
  return (
    <>
      <div className={classes.policyContainer}>
        <div className={classes.policyWrapper}>
          <h1 className={classes.policyTitle}>
            Shipping & Service Fulfillment Policy – Artist Next Door
          </h1>
          <p className={classes.lastUpdated}>Last Updated: 06th May 2025</p>

          <div className={classes.policyIntro}>
            <p>
              Artist Next Door ("we," "our," or "us") is a service-based
              platform facilitating the digital booking of performing artists.
              We do not deal in physical shipments or product deliveries. All
              services are fulfilled through online confirmations and in-person
              artist performances at the scheduled events.
            </p>
          </div>

          <div className={classes.policySection}>
            <h2>1. Service Fulfillment (Bookings & Confirmations)</h2>

            <div className={classes.subSection}>
              <h3>1.1 Digital Booking Confirmations</h3>
              <p>
                Upon successful payment processing via Razorpay{" "}
                <span className={classes.highlight}>
                  (currently applied for)
                </span>
                , users receive an instant confirmation via email and in-app
                notification.
              </p>
            </div>

            <div className={classes.subSection}>
              <h3>1.2 Booking Access & Tracking</h3>
              <p>
                Users may log in to their Artist Next Door account at any time
                to review booking details, updates, and status.
              </p>
            </div>

            <div className={classes.subSection}>
              <h3>1.3 Fulfillment Timeline</h3>
              <p>
                Artist performances are rendered on the scheduled event date as
                agreed upon during the booking process.
              </p>
            </div>
          </div>

          <div className={classes.policySection}>
            <h2>2. No Physical Shipments (Returns & Refunds Policy)</h2>
            <ul className={classes.policyList}>
              <li>
                Since Artist Next Door provides only digital bookings and
                service-based experiences, returns, reshipping, and replacements
                are not applicable.
              </li>
              <li>
                For booking-related concerns (including cancellations, refunds,
                or disputes), users must refer to our
                <a
                  href="/cancellation-refund-policy"
                  className={classes.policyLink}
                >
                  {" "}
                  Cancellation & Refund Policy
                </a>
                .
              </li>
            </ul>
          </div>

          <div className={classes.divider} />

          <div className={classes.policySection}>
            <h2>3. Geographic & International Limitations</h2>
            <ul className={classes.policyList}>
              <li>
                Artist bookings may be subject to location-based restrictions.
              </li>
              <li>
                If an artist is unable to perform due to geographic constraints,
                users will be notified in advance and issued a full refund (if
                applicable) as per our refund policy.
              </li>
            </ul>
          </div>

          <div className={classes.divider} />

          <div className={classes.policySection}>
            <h2>4. Customer Support & Queries</h2>
            <p>
              For any questions or assistance regarding service fulfillment,
              users may contact our support team at:
            </p>
            <p>
              Email:{" "}
              <a
                href="mailto:support@artistnextdoor.in"
                className={classes.emailLink}
              >
                support@artistnextdoor.in
              </a>
            </p>
            <p>Response Time: Within 24-48 hours (on business days).</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ShippingPolicy;
